import React from 'react';
import { LocaleString } from '@biw/intl';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as constants from '@biw/contests-constants';
import './status-title.scss';

const codeForProgramViewStatus = ( program ) => {
    switch ( program.programViewStatus ) {
        case constants.PVS__GOAL_SELECTION:
        case constants.PVS__GOAL_SELECTED:
            return 'paxProgress.pageHeader.duringGoalSelection';
        case constants.PVS__NO_PROGRESS:
            if ( program.isObjectives && !program.programHasStarted ) {
                return 'paxProgress.pageHeader.overview';
            }
            return 'paxProgress.pageHeader.noProgress';
        case constants.PVS__PROGRESS_LOADED_NO_ISSUANCE:
            if( program.programHasEnded ) {
                return 'dashboard.tile.common.waitingForFinal';
            }
            return 'paxProgress.pageHeader.duringProgramHeader';
        case constants.PVS__NO_GOAL_SELECTED:
            return 'paxProgress.pageHeader.noGoalSelected';
        case constants.PVS__FINAL_ISSUANCE:
            return 'paxProgress.pageHeader.finalResultsHeader';
    }
    return '';
};

const StatusTitle = ( { program } ) => {
    const code = codeForProgramViewStatus( program );
    const titleClasses = classNames(
        'program-view-status-label',
        'text-center',
        { 'branding-primary-text':  program.isGoalSelection }
    );
    return (
        <div>
            { code &&
                <LocaleString
                    TextComponent="div"
                    className={ titleClasses }
                    code={code} />
            }
        </div>
    );
};
export default StatusTitle;
StatusTitle.propTypes = {
    program: PropTypes.shape( {
        programViewStatus:  PropTypes.string
    } )
};

